/**
 * components/inspection/WorkerSelect.js — АЖИЛТНЫГ ЛАВЛАХААС СОНГОХ.
 *
 * ЯАГААД:
 *   Удирдамж, комисс, хариуцагч зэрэг газарт ТН-ийг ГАРААР бичдэг байсан
 *   тул: буруу ТН, буруу бичсэн нэр, ажлаас гарсан хүн бүртгэгдэх эрсдэл
 *   байв. Энд ТН-ээр эсвэл нэрээр хайж СОНГОНО — сонгомогц нэр, албан
 *   тушаал, бүтцийн нэгж нь лавлахаас ТАТАГДАНА.
 *
 * Эх сурвалж: GET /xab/workers (Resources/XAB/worker_lookup.py) — Redis дэх
 * ажилтны кэш. Хамрах хүрээг bnCode / tsehCode-оор хязгаарлана; аль нь ч
 * өгөгдөөгүй бол backend хэрэглэгчийн өөрийн нэгжээр хумина (эрхээс
 * гадуурх ажилтан буцахгүй).
 *
 * onChange(tn, worker) — worker нь { tn, name, position, tseh_code,
 *   tseh_name, bn_code, bn_name }. Цэвэрлэхэд (tn = undefined, worker = null).
 *
 * Props: value · onChange · bnCode · tsehCode · size · disabled · placeholder
 *        · initialWorker — засварын горимд сонгогдсон хүн хайлтын үр дүнд
 *          байхгүй ч нэрээрээ харагдана (зөвхөн ТН харагдахаас сэргийлнэ).
 *        · allowOtherUnits — «Бүх нэгжээс хайх» унтраалга гаргана.
 *
 * ⚠ БҮХ НЭГЖЭЭС ХАЙХ (2026-09-25): зөрчлийг арилгах хариуцагч нь тухайн
 *   хэсгийн хүн байх АЛБАГҮЙ — цахилгааны зөрчлийг Цахилгаан цех, өргөх
 *   механизмынхыг ЗМЗ арилгана. Нэгжээр хатуу хумибал тэр хүнийг ОГТ
 *   сонгож чадахгүй тул зөрчил эзэнгүй үлддэг байв.
 *
 * ⚠ УНТРААЛГА ХАСАГДСАН (2026-09-30): «☐ Бүх нэгжээс хайх» нь сонгогчийн
 *   ДООР хоёрдугаар мөр зурдаг байсан тул хүснэгтийн мөр бүр хоёр дахин
 *   өндөр болж, «Хариуцагч (эзэн)» багана замбараагүй харагдаж байв.
 *   Одоо хамрах хүрээ нь ӨӨРӨӨ нээгдэнэ: нэгжээс олдохгүй бол (2+
 *   тэмдэгт бичсэн үед) үйлдвэрийн бүх ажилтнаас хайж, үр дүнг
 *   «Бусад нэгжээс» гэсэн БҮЛЭГТ харуулна — хэрэглэгч өөр нэгжийн хүн
 *   сонгож байгаагаа хардаг ч нэмэлт мөр эзэлдэггүй.
 *   `showScopeToggle` — хуучин чагтыг заавал хэрэгтэй газарт нь гаргана.
 */
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Select, Spin } from "antd";
import { xabInspectionApi } from "src/api/xabApi";

export default function WorkerSelect({
  value,
  onChange,
  bnCode,
  tsehCode,
  size = "small",
  disabled,
  placeholder = "Нэр эсвэл ТН-ээр хайх",
  initialWorker,
  allowOtherUnits = false,
  // Хуучин «☐ Бүх нэгжээс хайх» чагтыг гаргах (анхдагчаар ХАРАГДАХГҮЙ)
  showScopeToggle = false,
  /* ── ГРУППЭЭР ХУМИХ (2026-10-26) ──────────────────────────────────
     Группийн `department_id`. Хэрэглэгч: «Илтгэгч дээр тухайн сонгогдсон
     хэсэг нэгжийн, хэрэв групп сонголттой бол тухайн группын ажилтны
     жагсаалтаас сонгох боломжтой байх».

     ⚠ Группийг КОДООР шүүж БОЛОХГҮЙ: ажилтан группийн түвшинд
       `negj_code`/`department_code`-оор бүртгэгддэггүй — лавлахын 9
       группийн кодоор хайхад 9/9 нь 0 ажилтан. Холбоос нь ЗӨВХӨН
       `worker.departmentid` (сервер 2026-10-26-наас буцаана).
     ⚠ Группт хүн ОЛДОХГҮЙ бол ХЭСГИЙН жагсаалт ХЭВЭЭР: лавлахад групп
       бүртгэгдсэн ч ажилтан хуваарилагдаагүй тохиолдол бий (жш 250502
       → 0). Хоосон болговол илтгэгчийг огт сонгож чадахгүй болно. */
  grpId = null,
}) {
  const [list, setList] = useState([]);
  // Өөр нэгжээс нөхөж олдсон ажилтнууд — тусдаа БҮЛЭГТ харагдана
  const [outside, setOutside] = useState([]);
  const [loading, setLoading] = useState(false);
  // «Бүх нэгжээс» — хэрэглэгч өөрөө асаана (анхдагчаар өөрийн нэгж)
  const [allUnits, setAllUnits] = useState(false);
  const timer = useRef(null);
  // Хайлтын үр дүнгээс гарсан ч сонгогдсон хүн нэрээрээ харагдана
  const [picked, setPicked] = useState(initialWorker || null);

  useEffect(() => {
    if (initialWorker) setPicked(initialWorker);
  }, [initialWorker]);

  const fetch = useCallback(
    (q) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(async () => {
        setLoading(true);
        try {
          const scoped = allUnits
            ? { workers: [] }
            : await xabInspectionApi.searchWorkers({
                q: q || undefined,
                bn_code: bnCode || undefined,
                tseh_code: tsehCode || undefined,
                limit: 50,
              });
          let mine = scoped?.workers || [];
          let other = [];
          /* ⚠ НӨХӨӨД ХАЙХ: нэгжээс олдоогүй (эсвэл хамрах хүрээ огт
             байхгүй) бол үйлдвэрийн бүх ажилтнаас. Сервер нь `all=1`
             дээр 2+ тэмдэгт шаарддаг тул бага бичсэн үед дуудахгүй. */
          const wide = allowOtherUnits || allUnits;
          if (wide && (allUnits || !mine.length) && String(q || "").trim().length >= 2) {
            const d2 = await xabInspectionApi.searchWorkers({
              q: q || undefined,
              all: 1,
              limit: 50,
            });
            const seen = new Set(mine.map((w) => String(w.tn)));
            other = (d2?.workers || []).filter((w) => !seen.has(String(w.tn)));
          }
          /* Группээр хумих — ЗӨВХӨН хүн олдвол (дээрх тайлбарыг үз) */
          if (grpId != null && String(grpId) !== "" && mine.length) {
            const inGrp = mine.filter(
              (w) => String(w.departmentid || "") === String(grpId),
            );
            if (inGrp.length) mine = inGrp;
          }
          setList(mine);
          setOutside(other);
        } catch (e) {
          setList([]);
        } finally {
          setLoading(false);
        }
      }, 300);
    },
    /* ⚠ `grpId` ч ХАМААРАЛ — групп солигдоход жагсаалт дахин шүүгдэх
       ёстой, эс бөгөөс өмнөх группийн ажилтнууд үлдэнэ. */
    [bnCode, tsehCode, allUnits, allowOtherUnits, grpId],
  );

  // Цех/хэсэг солигдоход жагсаалтыг дахин татна — өмнөх нэгжийн ажилтан
  // сонголтод үлдэх ёсгүй.
  useEffect(() => {
    fetch("");
    return () => clearTimeout(timer.current);
  }, [fetch]);

  const options = useMemo(() => {
    const toOpt = (w) => ({
      value: String(w.tn),
      // title — хайлтын түлхүүр ба сонгогдсон үеийн текст
      title: `${w.name || "?"} (${w.tn})`,
      worker: w,
      label: (
        <div style={{ lineHeight: 1.25 }}>
          <div style={{ fontWeight: 600 }}>
            {w.name || "?"}
            <span style={{ color: "#8c8c8c", fontWeight: 400 }}> · {w.tn}</span>
          </div>
          <div style={{ fontSize: 11, color: "#8c8c8c" }}>
            {(w.position || "—").trim()}
            {w.tseh_name ? ` · ${w.tseh_name.trim()}` : ""}
          </div>
        </div>
      ),
    });

    const rows = [...list];
    if (picked && !rows.some((w) => String(w.tn) === String(picked.tn))) {
      rows.unshift(picked);
    }
    // Өөр нэгжийн хүн байвал БҮЛЭГЛЭЖ харуулна — «яагаад энэ хүн гарч
    // ирэв» гэсэн асуулт төрөхгүй, нэмэлт мөр ч эзлэхгүй.
    if (!outside.length) return rows.map(toOpt);
    const groups = [];
    if (rows.length) {
      groups.push({ label: "Өөрийн нэгжээс", options: rows.map(toOpt) });
    }
    groups.push({ label: "Бусад нэгжээс", options: outside.map(toOpt) });
    return groups;
  }, [list, outside, picked]);

  const select = (
    <Select
      showSearch
      allowClear
      size={size}
      disabled={disabled}
      style={{ width: "100%" }}
      placeholder={placeholder}
      value={value ? String(value) : undefined}
      // Сервер тал дээр хайдаг тул клиент талын шүүлтийг УНТРААНА —
      // эс бөгөөс сая ирсэн үр дүн дахин шүүгдэж хоосон харагдана.
      filterOption={false}
      onSearch={fetch}
      notFoundContent={loading ? <Spin size="small" /> : "Олдсонгүй"}
      optionLabelProp="title"
      options={options}
      onChange={(tn, opt) => {
        const w = opt?.worker || null;
        setPicked(w);
        onChange && onChange(tn, w);
      }}
    />
  );

  if (!allowOtherUnits) return select;

  /* ⚠ Анхдагчаар НЭМЭЛТ МӨР ГАРГАХГҮЙ — хамрах хүрээ өөрөө нээгддэг.
     Чагт хэрэгтэй газарт `showScopeToggle` илт өгнө. */
  if (!showScopeToggle) return select;

  return (
    <div>
      {select}
      <label
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 5,
          marginTop: 3,
          fontSize: 10.5,
          color: allUnits ? "#0F6E56" : "#8A94A6",
          cursor: disabled ? "default" : "pointer",
          userSelect: "none",
        }}
      >
        <input
          type="checkbox"
          checked={allUnits}
          disabled={disabled}
          onChange={(e) => setAllUnits(e.target.checked)}
          style={{ margin: 0, cursor: disabled ? "default" : "pointer" }}
        />
        Бүх нэгжээс хайх
        {allUnits ? (
          <span style={{ color: "#B45309" }}>
            (нэр/ТН-ээс 2-оос доошгүй үсэг бичнэ)
          </span>
        ) : null}
      </label>
    </div>
  );
}
